import * as React from 'react'

function IconPhone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={37}
      height={37}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.82 17.875l3.895 3.895a3.824 3.824 0 005.404 0 5.674 5.674 0 018.024 8.025c-5.427 5.404-14.208 5.404-19.618-.006L6.8 24.065c-5.416-5.416-5.41-14.192 0-19.601a5.674 5.674 0 018.024 8.024c-1.497 1.473-1.497 3.896-.006 5.387z"
        stroke="#C4C4C4"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconPhone
